import { Button, Text } from "@ui-kitten/components";
import Container from "components/Container";
import Dialog from "components/Dialog";
import Login from "components/LoginForm";
import Spacer from "components/Spacer";
import { logout } from "features/slices/authSlice";
import useAuth from "hooks/useAuth";
import { getSanityImage } from "lib/sanity";
import { Faq, ShopPagePhaseTwo } from "lib/sanity.types";
import React, { useState } from "react";
import { ImageBackground, View } from "react-native";
import { useDispatch } from "react-redux";
import PortableText from "screens/Shop/components/PortableText";
import Faqs from "./components/Faqs";
import PlanGroups from "./components/PlanGroups";
import Terms from "./components/Terms";

const StepOne = ({
  shopPage,
  faqs,
  onPlanGroupPurchase,
}: {
  shopPage: ShopPagePhaseTwo;
  faqs?: Faq[] | null;
  onPlanGroupPurchase?: (groupName: string) => void;
}) => {
  const [showLogin, setShowLogin] = useState(false);
  const { isLoggedIn, username } = useAuth();
  const dispatch = useDispatch();
  const showLoginForm = () => {
    setShowLogin(true);
  };
  const handleLogout = () => {
    dispatch(logout());
  };

  return (
    <ImageBackground
      className="pt-16 md:pt-32"
      style={{
        backgroundColor: shopPage.stepOneBackgroundImageFilterColor.hex,
      }}
      source={{
        uri: getSanityImage(shopPage.stepOneBackgroundImage.asset._ref),
      }}
      imageStyle={{
        opacity: 0.3,
      }}
    >
      <View className="text-center">
        <View className="mb-16 md:mb-32 px-2">
          <PortableText value={shopPage.stepOneTitle} />
        </View>

        <PlanGroups groups={shopPage.groups} onPurchase={onPlanGroupPurchase} />

        <View className="mt-8 flex-row items-center justify-center">
          {!isLoggedIn && (
            <View>
              <Text status="control" category="h6">
                Already have an account?
              </Text>
              <Button
                status="control"
                onPress={showLoginForm}
                appearance="ghost"
              >
                Login here to purchase
              </Button>
            </View>
          )}
          {isLoggedIn && username && (
            <View>
              <Text status="control">Welcome, {username}!</Text>
              <Button
                appearance="ghost"
                status="control"
                onPress={handleLogout}
              >
                Logout
              </Button>
            </View>
          )}
        </View>

        {faqs && faqs.length > 0 && (
          <Spacer margin={64}>
            <Container>
              <Faqs faqs={faqs} />
            </Container>
          </Spacer>
        )}

        {shopPage.additionalCreative && (
          <View className="mt-32">
            <img
              src={getSanityImage(shopPage.additionalCreative.asset._ref)}
              alt=""
            />
          </View>
        )}

        <View className="mt-32 mb-8">
          <Terms tenantSubdomain={shopPage.subdomain} />
        </View>
      </View>

      <Dialog
        visible={showLogin && !isLoggedIn}
        cancelText="Close"
        onCancel={() => setShowLogin(false)}
      >
        <Login allowSignup={false} title="Login" />
      </Dialog>
    </ImageBackground>
  );
};

export default StepOne;
